import { render, staticRenderFns } from "./DockRight.vue?vue&type=template&id=7481e512"
import script from "./DockRight.vue?vue&type=script&lang=js"
export * from "./DockRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports